import { fromJS } from "immutable";
import * as actionTypes from "./actionTypes";

const initialState = fromJS({
  accountData: {
    isLoading: true,
    data: {},
    error: ""
  },
  visibility: false,
  toUpdate: false
});

const needAssistance = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetchDataSuccessType:
      return state
        .setIn(["accountData", "data"], action.payload)
        .setIn(["toUpdate"], !state.getIn(["toUpdate"]));
    case actionTypes.showNaDrawerType:
      return state
        .setIn(["visibility"], !state.getIn(["visibility"]))
        .setIn(["toUpdate"], state.getIn([false]));
    case actionTypes.submissionDoneType:
      return state
        .setIn(["visibility"], !state.getIn(["visibility"]))
        .setIn(["toUpdate"], !state.getIn(["toUpdate"]));
    default:
      return state;
  }
};

export default needAssistance;
